/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BbsCategoryCreateReqVo,
  BbsCategoryUpdateReqVo,
  BbsContentCreateReqVo,
  BbsContentUpdateReqVo,
  ResponseBbsCategoryInfoRespVo,
  ResponseBbsContentInfoRespVo,
  ResponseGetBbsContentInfoRespVo,
  ResponseListBbsCategoryInfoRespVo,
  ResponseListGetBbsCategoryTreeRespVo,
  ResponseListGetBbsContentGroupByCategoryRespVo,
  ResponseLong,
  ResponsePageDataBbsContentInfoRespVo,
  ResponsePageDataGetBasicBbsContentPageListRespVo,
} from '../models/index';
import {
    BbsCategoryCreateReqVoFromJSON,
    BbsCategoryCreateReqVoToJSON,
    BbsCategoryUpdateReqVoFromJSON,
    BbsCategoryUpdateReqVoToJSON,
    BbsContentCreateReqVoFromJSON,
    BbsContentCreateReqVoToJSON,
    BbsContentUpdateReqVoFromJSON,
    BbsContentUpdateReqVoToJSON,
    ResponseBbsCategoryInfoRespVoFromJSON,
    ResponseBbsCategoryInfoRespVoToJSON,
    ResponseBbsContentInfoRespVoFromJSON,
    ResponseBbsContentInfoRespVoToJSON,
    ResponseGetBbsContentInfoRespVoFromJSON,
    ResponseGetBbsContentInfoRespVoToJSON,
    ResponseListBbsCategoryInfoRespVoFromJSON,
    ResponseListBbsCategoryInfoRespVoToJSON,
    ResponseListGetBbsCategoryTreeRespVoFromJSON,
    ResponseListGetBbsCategoryTreeRespVoToJSON,
    ResponseListGetBbsContentGroupByCategoryRespVoFromJSON,
    ResponseListGetBbsContentGroupByCategoryRespVoToJSON,
    ResponseLongFromJSON,
    ResponseLongToJSON,
    ResponsePageDataBbsContentInfoRespVoFromJSON,
    ResponsePageDataBbsContentInfoRespVoToJSON,
    ResponsePageDataGetBasicBbsContentPageListRespVoFromJSON,
    ResponsePageDataGetBasicBbsContentPageListRespVoToJSON,
} from '../models/index';

export interface AnnBbsCategoryIdDeleteRequest {
    id: number;
}

export interface AnnBbsCategoryIdGetRequest {
    id: number;
}

export interface AnnBbsCategoryIdPutRequest {
    id: number;
    bbsCategoryUpdateReqVo?: BbsCategoryUpdateReqVo;
}

export interface AnnBbsCategoryListGetRequest {
    level?: number;
    parentId?: number;
    enable?: number;
}

export interface AnnBbsCategoryPostRequest {
    bbsCategoryCreateReqVo?: BbsCategoryCreateReqVo;
}

export interface AnnBbsContentIdDeleteRequest {
    id: number;
}

export interface AnnBbsContentIdGetRequest {
    id: number;
}

export interface AnnBbsContentIdPutRequest {
    id: number;
    bbsContentUpdateReqVo?: BbsContentUpdateReqVo;
}

export interface AnnBbsContentListGetRequest {
    currentPage: number;
    pageSize: number;
    keyword?: string;
    categoryId?: number;
    enable?: number;
    startTime?: string;
    endTime?: string;
}

export interface AnnBbsContentPostRequest {
    bbsContentCreateReqVo?: BbsContentCreateReqVo;
}

export interface AnnBbsCurrentContentIdGetRequest {
    id: number;
}

export interface AnnBbsCurrentContentListByCategoryIdsGetRequest {
    currentPage: number;
    pageSize: number;
    categoryIds?: Array<number>;
}

export interface AnnBbsCurrentContentListGetRequest {
    currentPage: number;
    pageSize: number;
    keyword?: string;
    categoryId?: number;
}

/**
 * 
 */
export class BbsBbsControllerApi extends runtime.BaseAPI {

    /**
     * 公告分类信息删除 公告分类信息删除
     * 公告分类信息删除
     */
    async annBbsCategoryIdDeleteRaw(requestParameters: AnnBbsCategoryIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling annBbsCategoryIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ann-bbs/category/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 公告分类信息删除 公告分类信息删除
     * 公告分类信息删除
     */
    async annBbsCategoryIdDelete(requestParameters: AnnBbsCategoryIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.annBbsCategoryIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定编号,获取分类信息
     * 指定编号,获取分类信息
     */
    async annBbsCategoryIdGetRaw(requestParameters: AnnBbsCategoryIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBbsCategoryInfoRespVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling annBbsCategoryIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ann-bbs/category/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBbsCategoryInfoRespVoFromJSON(jsonValue));
    }

    /**
     * 指定编号,获取分类信息
     * 指定编号,获取分类信息
     */
    async annBbsCategoryIdGet(requestParameters: AnnBbsCategoryIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBbsCategoryInfoRespVo> {
        const response = await this.annBbsCategoryIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 修改公告分类信息 修改公告分类信息 无限分类
     * 修改公告分类信息
     */
    async annBbsCategoryIdPutRaw(requestParameters: AnnBbsCategoryIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling annBbsCategoryIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ann-bbs/category/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BbsCategoryUpdateReqVoToJSON(requestParameters['bbsCategoryUpdateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 修改公告分类信息 修改公告分类信息 无限分类
     * 修改公告分类信息
     */
    async annBbsCategoryIdPut(requestParameters: AnnBbsCategoryIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.annBbsCategoryIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 获取分类列表(不分页) 获取分类列表(不分页)
     * 获取分类列表(不分页)
     */
    async annBbsCategoryListGetRaw(requestParameters: AnnBbsCategoryListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListBbsCategoryInfoRespVo>> {
        const queryParameters: any = {};

        if (requestParameters['level'] != null) {
            queryParameters['level'] = requestParameters['level'];
        }

        if (requestParameters['parentId'] != null) {
            queryParameters['parentId'] = requestParameters['parentId'];
        }

        if (requestParameters['enable'] != null) {
            queryParameters['enable'] = requestParameters['enable'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ann-bbs/category/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListBbsCategoryInfoRespVoFromJSON(jsonValue));
    }

    /**
     * 获取分类列表(不分页) 获取分类列表(不分页)
     * 获取分类列表(不分页)
     */
    async annBbsCategoryListGet(requestParameters: AnnBbsCategoryListGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListBbsCategoryInfoRespVo> {
        const response = await this.annBbsCategoryListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 创建公告分类信息 创建公告分类信息 无限分类
     * 创建公告分类信息
     */
    async annBbsCategoryPostRaw(requestParameters: AnnBbsCategoryPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ann-bbs/category`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BbsCategoryCreateReqVoToJSON(requestParameters['bbsCategoryCreateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 创建公告分类信息 创建公告分类信息 无限分类
     * 创建公告分类信息
     */
    async annBbsCategoryPost(requestParameters: AnnBbsCategoryPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.annBbsCategoryPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * bbs内容删除 bbs内容删除
     * bbs内容删除
     */
    async annBbsContentIdDeleteRaw(requestParameters: AnnBbsContentIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling annBbsContentIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ann-bbs/content/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * bbs内容删除 bbs内容删除
     * bbs内容删除
     */
    async annBbsContentIdDelete(requestParameters: AnnBbsContentIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.annBbsContentIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定编号查询 指定编号查询
     * 指定编号查询
     */
    async annBbsContentIdGetRaw(requestParameters: AnnBbsContentIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBbsContentInfoRespVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling annBbsContentIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ann-bbs/content/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBbsContentInfoRespVoFromJSON(jsonValue));
    }

    /**
     * 指定编号查询 指定编号查询
     * 指定编号查询
     */
    async annBbsContentIdGet(requestParameters: AnnBbsContentIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBbsContentInfoRespVo> {
        const response = await this.annBbsContentIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * bbs内容修改 bbs内容修改
     * bbs内容修改
     */
    async annBbsContentIdPutRaw(requestParameters: AnnBbsContentIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling annBbsContentIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ann-bbs/content/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BbsContentUpdateReqVoToJSON(requestParameters['bbsContentUpdateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * bbs内容修改 bbs内容修改
     * bbs内容修改
     */
    async annBbsContentIdPut(requestParameters: AnnBbsContentIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.annBbsContentIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * bbs内容列表(分页) bbs内容列表(分页)
     * bbs内容列表(分页)
     */
    async annBbsContentListGetRaw(requestParameters: AnnBbsContentListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataBbsContentInfoRespVo>> {
        if (requestParameters['currentPage'] == null) {
            throw new runtime.RequiredError(
                'currentPage',
                'Required parameter "currentPage" was null or undefined when calling annBbsContentListGet().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling annBbsContentListGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['keyword'] != null) {
            queryParameters['keyword'] = requestParameters['keyword'];
        }

        if (requestParameters['categoryId'] != null) {
            queryParameters['categoryId'] = requestParameters['categoryId'];
        }

        if (requestParameters['enable'] != null) {
            queryParameters['enable'] = requestParameters['enable'];
        }

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ann-bbs/content/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataBbsContentInfoRespVoFromJSON(jsonValue));
    }

    /**
     * bbs内容列表(分页) bbs内容列表(分页)
     * bbs内容列表(分页)
     */
    async annBbsContentListGet(requestParameters: AnnBbsContentListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataBbsContentInfoRespVo> {
        const response = await this.annBbsContentListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * bbs内容添加 bbs内容添加
     * bbs内容添加
     */
    async annBbsContentPostRaw(requestParameters: AnnBbsContentPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ann-bbs/content`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BbsContentCreateReqVoToJSON(requestParameters['bbsContentCreateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * bbs内容添加 bbs内容添加
     * bbs内容添加
     */
    async annBbsContentPost(requestParameters: AnnBbsContentPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.annBbsContentPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定内容编号, 查询内容信息详情 指定内容编号, 获取内容信息详情
     * 指定内容编号, 获取内容信息详情
     */
    async annBbsCurrentContentIdGetRaw(requestParameters: AnnBbsCurrentContentIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseGetBbsContentInfoRespVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling annBbsCurrentContentIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ann-bbs/current/content/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseGetBbsContentInfoRespVoFromJSON(jsonValue));
    }

    /**
     * 指定内容编号, 查询内容信息详情 指定内容编号, 获取内容信息详情
     * 指定内容编号, 获取内容信息详情
     */
    async annBbsCurrentContentIdGet(requestParameters: AnnBbsCurrentContentIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseGetBbsContentInfoRespVo> {
        const response = await this.annBbsCurrentContentIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定多个分类编号,获取分类下内容信息列表 指定多个分类编号,获取分类下内容信息列表(只显示本级,下级不显示)按categoryId分组，无关键词筛选
     * 指定多个分类编号,获取分类下内容信息列表
     */
    async annBbsCurrentContentListByCategoryIdsGetRaw(requestParameters: AnnBbsCurrentContentListByCategoryIdsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListGetBbsContentGroupByCategoryRespVo>> {
        if (requestParameters['currentPage'] == null) {
            throw new runtime.RequiredError(
                'currentPage',
                'Required parameter "currentPage" was null or undefined when calling annBbsCurrentContentListByCategoryIdsGet().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling annBbsCurrentContentListByCategoryIdsGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['categoryIds'] != null) {
            queryParameters['categoryIds'] = requestParameters['categoryIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ann-bbs/current/content/list-by-category-ids`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListGetBbsContentGroupByCategoryRespVoFromJSON(jsonValue));
    }

    /**
     * 指定多个分类编号,获取分类下内容信息列表 指定多个分类编号,获取分类下内容信息列表(只显示本级,下级不显示)按categoryId分组，无关键词筛选
     * 指定多个分类编号,获取分类下内容信息列表
     */
    async annBbsCurrentContentListByCategoryIdsGet(requestParameters: AnnBbsCurrentContentListByCategoryIdsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListGetBbsContentGroupByCategoryRespVo> {
        const response = await this.annBbsCurrentContentListByCategoryIdsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定分类编号,获取分类下内容信息列表(只显示本级,下级不显示)分页  筛选条件为关键词标题 指定分类编号,获取分类下内容信息列表 指定分类编号,获取分类下内容信息列表(只显示本级,下级不显示)分页  筛选条件为关键词标题
     * 指定分类编号,获取分类下内容信息列表
     */
    async annBbsCurrentContentListGetRaw(requestParameters: AnnBbsCurrentContentListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataGetBasicBbsContentPageListRespVo>> {
        if (requestParameters['currentPage'] == null) {
            throw new runtime.RequiredError(
                'currentPage',
                'Required parameter "currentPage" was null or undefined when calling annBbsCurrentContentListGet().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling annBbsCurrentContentListGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['keyword'] != null) {
            queryParameters['keyword'] = requestParameters['keyword'];
        }

        if (requestParameters['categoryId'] != null) {
            queryParameters['categoryId'] = requestParameters['categoryId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ann-bbs/current/content/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataGetBasicBbsContentPageListRespVoFromJSON(jsonValue));
    }

    /**
     * 指定分类编号,获取分类下内容信息列表(只显示本级,下级不显示)分页  筛选条件为关键词标题 指定分类编号,获取分类下内容信息列表 指定分类编号,获取分类下内容信息列表(只显示本级,下级不显示)分页  筛选条件为关键词标题
     * 指定分类编号,获取分类下内容信息列表
     */
    async annBbsCurrentContentListGet(requestParameters: AnnBbsCurrentContentListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataGetBasicBbsContentPageListRespVo> {
        const response = await this.annBbsCurrentContentListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * bbs树形数据(全部数据) 注意判断是否登录 bbs树形数据(全部数据)
     * bbs树形数据(全部数据)
     */
    async annBbsCurrentTreeGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListGetBbsCategoryTreeRespVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ann-bbs/current/tree`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListGetBbsCategoryTreeRespVoFromJSON(jsonValue));
    }

    /**
     * bbs树形数据(全部数据) 注意判断是否登录 bbs树形数据(全部数据)
     * bbs树形数据(全部数据)
     */
    async annBbsCurrentTreeGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListGetBbsCategoryTreeRespVo> {
        const response = await this.annBbsCurrentTreeGetRaw(initOverrides);
        return await response.value();
    }

}
